import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const strategy = {
  namespaced: true,
  state: {
    strategies: []
  },
  getters,
  mutations,
  actions
};

